import type {
  ApiAddressCountry,
  UiAddressCountry,
  ApiAddressRecord,
  ApiAddress,
  UiAddress,
} from '../../schemas/address.schema';

export function mapAddressFromApi(
  address?: ApiAddressRecord,
): UiAddress | undefined {
  if (!address) return undefined;
  return {
    city: address.city ?? '',
    country: [{ value: address.country }],
    isAddressPublic: address.isAddressPublic ?? undefined,
    street: address.street ?? undefined,
    zip: address.zip ?? '',
  };
}

export function mapAddressCountryFromApi(
  addressCountry?: ApiAddressCountry,
): UiAddressCountry | undefined {
  if (!addressCountry) return undefined;
  return {
    dialCode: addressCountry.dialCode,
    label: addressCountry.label,
    value: addressCountry.countryCode,
  };
}

export function mapAddressToApi(
  address?: Partial<UiAddress>,
): Partial<ApiAddress> | undefined {
  try {
    if (!address) return undefined;
    return {
      ...address,
      country: (address?.country?.[0]?.value ?? '') as any,
    };
  } catch {
    return undefined;
  }
}
